export const isInOffice = () => !!window.Office;
